import PropTypes from 'prop-types';
import React from 'react';
import NumberFormat from 'react-number-format';

function CepInput({ id, inputRef, onChange, ...other }) {
  return (
    <NumberFormat
      id={id}
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            id,
            value: values.value,
          },
        });
      }}
      format="#####-###"
      mask="_"
    />
  );
}

CepInput.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CepInput;
